import { type FC, lazy } from "react"

import Button from "~/components/Button"
import FeatureIntroduction from "~/components/FeatureIntroduction"
import routes from "~/utilities/routes"

const ExamImage = lazy(() => import("./ExamImage"))

const Exam: FC<{ courseId: number }> = ({ courseId }) => (
	<div className="mt-6">
		<FeatureIntroduction
			illustration={ExamImage}
			title="Exam"
			text="Test the knowledge of your users with an exam. This will help you to identify the strengths and weaknesses of your users and to tailor the course content to their needs."
		>
			<Button variant="primary" onClick={routes.course.exam(courseId)}>
				Go to exam
			</Button>
		</FeatureIntroduction>
	</div>
)

export default Exam
